import { toast } from 'sonner';

import { msCatalystApi } from '../services/api/ms-catalyst-api.js';

export const getExportFile = async (path, table, options) => {
  const TYPES = {
    csv: {
      headers: {},
      blob: 'text/csv',
    },
    xlsx: {
      headers: {
        responseType: 'arraybuffer',
      },
      blob: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    },
  };

  if (!TYPES[options.fileType]) {
    toast.warning('O tipo de Ficheiro é inválido');
    return;
  }

  const getExportData = await msCatalystApi.post(
    path,
    options,
    TYPES[options.fileType].headers,
  );

  const exportData = getExportData.data;

  const currentTime = new Date();
  const unixTimestamp = currentTime.getTime();

  const blob = new Blob([exportData], { type: TYPES[options.fileType].blob });
  const url = window.URL.createObjectURL(blob);

  const a = document.createElement('a');
  a.href = url;

  if (options?.winnersType) {
    a.download = `${unixTimestamp}_${table}_${options.winnersType}.${options.fileType}`;
  } else {
    a.download = `${unixTimestamp}_${table}.${options.fileType}`;
  }

  a.click();

  window.URL.revokeObjectURL(url);
};

export const getImportFile = async (file) => {
  try {
    const formData = new FormData();
    formData.append('file', file);

    const fileName = file.name;
    const fileExtension = fileName.split('.').pop().toLowerCase();

    if (!['csv', 'xlsx'].includes(fileExtension)) {
      toast.error('Tipo de Ficheiro Inválido');
      return;
    }

    const { data: response } = await msCatalystApi.post(
      `/misc/${fileExtension}-to-json`,
      formData,
    );

    console.log('response', response);

    const headers = Object.keys(response.data[0]).map((key, index) => ({
      value: key,
      label: `${key} (coluna ${index + 1})`,
    }));
    toast.success('Ficheiro carregado com sucesso!');

    return { headers, data: response.data };
  } catch (err) {
    console.log(err);
    toast.error('Erro ao importar');
  }
};
